<template>
    <div class="takequiz">
      <hr>
    <ul>
        <li v-for="choice in choices" :key="choice">
            <button v-on:click="selectedAnswer(choice)">{{choice}}</button>
            </li>
    </ul>
    </div>
</template>
<script>
export default {
  name: 'QuestionChoice',
   data () {
    return {
      //  choices: ['A','B','C','D'],
    }
  },
    methods: {
      selectedAnswer: function(choice) {
        console.log('i choose ', choice)
        let submit = {
          choice: choice,
          answer: this.answer
        }
        this.$emit('grade',submit)
        // this.$emit('selected-answer')
      }
    },
  props: {
    msg: String,
    answer: String,
    choices: {
      type: Array
    }
  }
}
</script>

<style>

</style>
